import React from 'react';
import './ProductImageCarousel.css';

const images = [
  '/images/Test1.png',
  '/images/Test2.png',
  '/images/Test3.png',
  '/images/Test2.png',
  '/images/Test5.png',
];

const ProductImageCarousel = () => {
  return (
    <div className="image-carousel-container">
      <div className="txt-center" style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:'20px'}}>
        <h4>Our Services Used By Leading Healthcare Providers Worldwide</h4>
      </div>
      <div className="image-carousel-track" style={{marginTop:'50px'}}>
        {images.map((image, index) => (
          <img key={index} src={image} alt={`Testimonial ${index + 1}`} className="carousel-image" />
        ))}
        {/* Duplicate images for seamless looping */}
        {images.map((image, index) => (
          <img key={`duplicate-${index}`} src={image} alt={`Testimonial ${index + 1}`} className="carousel-image" />
        ))}
      </div>
    </div>
  );
};

export default ProductImageCarousel; 